var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18784 18.428C5.24141 18.428 5.29498 18.4227 5.34855 18.4146L9.85391 17.6244C9.90748 17.6137 9.95837 17.5896 9.99587 17.5494L21.3503 6.19498C21.3752 6.1702 21.3949 6.14076 21.4083 6.10836C21.4218 6.07596 21.4287 6.04122 21.4287 6.00614C21.4287 5.97106 21.4218 5.93632 21.4083 5.90392C21.3949 5.87151 21.3752 5.84208 21.3503 5.8173L16.8986 1.36283C16.8477 1.31194 16.7807 1.28516 16.7084 1.28516C16.6361 1.28516 16.5691 1.31194 16.5182 1.36283L5.16373 12.7173C5.12355 12.7575 5.09944 12.8057 5.08873 12.8593L4.29855 17.3646C4.27249 17.5081 4.2818 17.6558 4.32568 17.7949C4.36955 17.934 4.44666 18.0603 4.55033 18.1628C4.72712 18.3343 4.94944 18.428 5.18784 18.428ZM6.99319 13.7566L16.7084 4.04409L18.6718 6.00748L8.95659 15.72L6.57534 16.1405L6.99319 13.7566ZM21.8566 20.678H2.1423C1.66819 20.678 1.28516 21.0611 1.28516 21.5352V22.4994C1.28516 22.6173 1.38158 22.7137 1.49944 22.7137H22.4994C22.6173 22.7137 22.7137 22.6173 22.7137 22.4994V21.5352C22.7137 21.0611 22.3307 20.678 21.8566 20.678Z",
    fill: "#096DD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.8c15ec3b2cd7bd1cff43cc3b2d933363.svg";
export { ForwardRef as ReactComponent };